import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/Choicest_Fruit.png";
import Card from "react-bootstrap/Card";
import useInViewOnce from "../../hooks/useInViewOnce";

function About() {
  const { ref: valuesRef, inView: valuesInView, hasEntered: valuesSeen } = useInViewOnce({ once: false });

  const coreValues = [
    {
      title: "Ethical Innovation",
      body:
        "Developing and applying technology in ways that promote equity, responsibility, and human well-being.",
    },
    {
      title: "Service & Collaboration",
      body:
        "Working hand-in-hand with neighbors, partners, and organizations to address pressing challenges.",
    },
    {
      title: "Inclusivity & Community",
      body:
        "We embrace diverse perspectives, ensuring that everyone has a voice, role, and place in our initiatives, and every action we take prioritizes the well-being, growth, and connectedness of communities.",
    },
    {
      title: "Grassroots Outreach",
      body:
        "Through public events, community meetings, and one-on-one conversations, we spread our mission and attract those who share our passion for positive change.",
    },
  ];

  return (
    <Container fluid className="about-section about-page">
      <Particle />
      <Container className="about-container">
        <header className="about-hero">
          <h1 className="about-hero-title">
            About <span className="purple">Choicest Fruit</span>
          </h1>
          <p className="about-hero-lead">
            A social enterprise supporting human-centered innovation and community development.
          </p>
        </header>

        <Row className="about-top" xs={1} md={2}>
          <Col className="about-top-col">
            <h2 className="about-section-heading">
              Who <span className="purple">We Are</span>
            </h2>
            <Aboutcard />
          </Col>

          <Col className="about-top-col">
            <Card className="policy-card about-image-card" aria-label="Choicest Fruit">
              <img src={laptopImg} alt="Choicest Fruit" className="about-image" />
            </Card>
          </Col>
        </Row>

        <section className="about-section-block" aria-label="Core Values">
          <h2 className="about-section-heading">
            Our <span className="purple">Core Values</span>
          </h2>

          <div
            ref={valuesRef}
            className={`about-values-grid${valuesSeen ? " about-seen" : ""}${
              valuesInView ? " about-inview" : ""
            }`}
          >
            {coreValues.map((value, index) => (
              <Card
                key={value.title}
                className="policy-card about-value-card about-anim-card about-anim-bounce"
                style={{ animationDelay: `${index * 90}ms` }}
              >
                <Card.Body>
                  <blockquote className="blockquote mb-0">
                    <div className="about-value-title">{value.title}</div>
                    <p className="about-text about-value-text">{value.body}</p>
                  </blockquote>
                </Card.Body>
              </Card>
            ))}
          </div>
        </section>

        <section className="about-section-block" aria-label="What We Believe">
          <h2 className="about-section-heading">
            What We <span className="purple">Believe</span>
          </h2>
          <Techstack />
        </section>
      </Container>
    </Container>
  );
}

export default About;
